// Something a section needs is not set up yet (APS-412, admin-d.md "Not configured"): one dim
// mono line in the section, what is missing and whose task it is ("Falta a chave de leitura do
// PostHog · tarefa do dono"). No notice box: nothing is wrong with the page.
export function NotConfigured({ missing, task }: { missing: string; task?: string | undefined }) {
  return (
    <p className="nc-line" role="status">
      {missing}
      {task ? <span> · {task}</span> : null}
    </p>
  )
}
